import React, {useState, useRef, useEffect} from 'react';
import './App.css';

const sendMessageToApp = (message) => {
  // iOS
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.reactNative) {
    window.webkit.messageHandlers.reactNative.postMessage(message);
  }
  // Android
  if (window.android) {
    window.android.postMessage(message);
  }
};

const CallAndEmail = () => {
  const [bShowEmail, setShowEmail] = useState(false);
  // 处理 "Email Us" 按钮点击事件
  const handleEmailUsClick = () => {
    //alert('Email Us...');
    sendMessageToApp('email us');
  };

  useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const version = queryParams.get("version");
      console.log("version" + version);
      if(version !=='' && version !==null){
        setShowEmail(true);
      }
      
    }, []); // 空数组表示只在组件挂载时运行一次

  return (
    <div className="chat-widget">
     {bShowEmail && 
     (
      <button onClick={handleEmailUsClick} className="chat-button">
          <img
            src={require('./img/email.svg')}
            alt="Email Icon"
            className="button-icon"
          />
          <span className="button-text">Email Us</span>
          
          <img
            src={require('./img/EmailBig.svg')}
            alt="Email Icon"
            className="button-icon-2"
          />
      </button>
      ) 
           
    }
      

      <div className="chat-header">
        <img
          src={require('./img/hi.svg')}
          alt="Chat Icon"
          className="chat-icon"
        />
        <div className="chat-header-text">Hi! How can I help you today?</div>
      </div>
    </div>
  );
};

export default CallAndEmail;
